module.exports = __webpack_public_path__ + "img/green-btn-long.e107bcb.png";